import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "left",
  "use": "left-usage",
  "viewBox": "0 0 4 9",
  "content": "<symbol viewBox=\"0 0 4 9\" id=\"left\"><path fill-rule=\"evenodd\" d=\"M0 4.5L4 0v9z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/caret/left.svg
// module id = ./src/assets/icons/caret/left.svg
// module chunks = 2